const _excluded = ["lookup", "onChange", "totalPossibleOptions"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import debounce from "../../utils/debounce";
import { MultiSelect, defaultProps } from "./MultiSelect";











const uniqueOptions = (optionsValue) => (option, i, arr) =>
arr.findIndex((o) => o[optionsValue] === option[optionsValue]) === i;

function notEmpty(value) {
  return value !== null && value !== undefined;
}

export const debounceTime = 200;

export class LookupMultiSelect extends Component {


  static getDerivedStateFromProps(props) {
    return { totalPossibleOptions: props.totalPossibleOptions };
  }

  constructor(props) {
    super(props);
    this.state = {
      lookupOptions: [],
      selectedOptions: [],
      totalPossibleOptions: props.totalPossibleOptions
    };
    this.onChange = this.onChange.bind(this);
    this.onFilter = debounce(this.onFilter.bind(this), debounceTime);
  }

  onChange(value) {
    this.props.onChange(value);
    const options = this.combineOptions();

    const selectedOptions = value.
    map((v) => options.find((o) => o[this.props.optionsValue] === v)).
    filter(notEmpty);

    this.setState({ selectedOptions });
  }

  async onFilter(searchTerm) {
    if (searchTerm.length) {
      const { options, count } = await this.props.lookup(searchTerm);

      const lookupOptions = options.map((o) => _objectSpread(_objectSpread({},
      o), {}, {
        [this.props.optionsValue]: o.value,
        [this.props.optionsLabel]: o.label })
      );

      this.setState({ lookupOptions, totalPossibleOptions: count });
    }

    if (!searchTerm.length) {
      this.setState({
        lookupOptions: [],
        totalPossibleOptions: this.props.totalPossibleOptions
      });
    }
  }

  combineOptions() {
    return [
    ...this.props.options,
    ...this.state.lookupOptions,
    ...this.state.selectedOptions].
    filter(uniqueOptions(this.props.optionsValue));
  }

  render() {
    const _this$props = this.props,{ lookup, onChange, totalPossibleOptions } = _this$props,rest = _objectWithoutProperties(_this$props, _excluded);
    const filteredTotalPossibleOptions = this.state.totalPossibleOptions;
    return /*#__PURE__*/(
      React.createElement(MultiSelect, _extends({},
      rest, {
        onChange: this.onChange,
        onFilter: this.onFilter,
        totalPossibleOptions: filteredTotalPossibleOptions,
        options: this.combineOptions() })
      ));

  }
}_defineProperty(LookupMultiSelect, "defaultProps", _objectSpread(_objectSpread({}, defaultProps), {}, { value: [] }));